import React, { useEffect, useState } from "react";

import { configurationsFromFile, setBaseUrl } from "../../apiUtils";

import Routes from "./routes";

const App: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    configurationsFromFile();
    setTimeout(() => {
      setBaseUrl();
      setLoaded(true);
    }, 2000);
  }, []);

  if (!loaded) {
    return null;
  }
  return <Routes />;
};

export default App;
